<div class="layout-topbar p-shadow-4">
    <div class="layout-topbar-left">
        <a class="layout-topbar-logo" routerLink="/">
            <img alt="ultima-layout" id="app-logo" src="assets/branding/patang-logo.svg" style="height: 4.5rem">
        </a>

        <a class="layout-menu-button p-shadow-6" (click)="appMain.onMenuButtonClick($event)" pRipple>
            <i class="pi pi-chevron-right"></i>
        </a>


        <a class="layout-topbar-mobile-button">
            <div>
                <img style="height: 3rem; cursor: not-allowed" src="assets/branding/tw-logo-white.png" alt="">
            </div>
            <i (click)="appMain.onTopbarMobileButtonClick($event)" class="pi pi-ellipsis-v fs-large" pRipple></i>
        </a>
    </div>

    <div class="layout-topbar-right" [ngClass]="{'layout-topbar-mobile-active': appMain.mobileTopbarActive}">
        <div class="layout-topbar-actions-left">
            <p-megaMenu [model]="model" styleClass="layout-megamenu p-d-none"></p-megaMenu>
            <p-multiSelect
                #companiesSelection
                class="company-selection companies-selection"
                (onPanelHide)="appMain.onTopbarItemClick($event, '');storeSelectedCompanies()"
                [(ngModel)]="selectedCompanies"
                [baseZIndex]="1000"
                [defaultLabel]="'Select Companies'"
                optionLabel="domainName"
                placeholder="Select Companies"
                styleClass="p-d-flex p-d-xl-none p-text-secondary"
                [filter]="true"
                filterBy="domainName"
                [options]="companies" [selectedItemsLabel]="'{0} companies selected'"
                [showHeader]="true"
            >
                <ng-template pTemplate="header">
                    <div class="apply-button p-ai-center">
                        <button (click)="storeSelectedCompanies(); companiesSelection.close($event)"
                                pButton pRipple type="button"
                                class="p-button-icon p-m-0 apply-button-size check-button-size"
                                icon="pi pi-check"></button>
                    </div>
                </ng-template>
            </p-multiSelect>
        </div>
        <div class="layout-topbar-actions-right">
            <ul class="layout-topbar-items">

                <li class="layout-topbar-item layout-search-item p-d-none">
                    <a class="layout-topbar-action rounded-circle" (click)="appMain.onTopbarItemClick($event, 'search')"
                       pRipple>
                        <i class="pi pi-search fs-large"></i>
                    </a>

                    <div class="layout-search-panel p-inputgroup" [@topbarActionPanelAnimation]="'visible'"
                         *ngIf="appMain.search" (@topbarActionPanelAnimation.done)="onSearchAnimationEnd($event)">
                        <span class="p-inputgroup-addon"><i class="pi pi-search"></i></span>
                        <input #searchInput type="text" pInputText placeholder="Search"
                               (click)="appMain.searchClick = true;" (keydown)="appMain.onSearchKeydown($event)">
                        <span class="p-inputgroup-addon">
                            <button pButton pRipple type="button" icon="pi pi-times"
                                    class="p-button-rounded p-button-text p-button-plain"
                                    (click)="appMain.searchClick = false;"></button>
                        </span>
                    </div>
                </li>
                <li class="layout-topbar-item notifications p-d-none">
                    <a class="layout-topbar-action rounded-circle"
                       (click)="appMain.onTopbarItemClick($event, 'notifications')" pRipple>
                        <span class="p-overlay-badge">
                            <i class="pi pi-bell fs-large"></i>
                            <span class="p-badge p-badge-warning p-badge-dot"></span>
                        </span>
                    </a>

                    <ul class="layout-topbar-action-panel p-shadow-6" [@topbarActionPanelAnimation]="'visible'"
                        *ngIf="appMain.activeTopbarItem === 'notifications'">
                        <li class="p-mb-3">
                            <span class="p-px-3 fs-small">You have <b>4</b> new notifications</span>
                        </li>
                        <li class="layout-topbar-action-item">
                            <div class="p-d-flex p-flex-row p-ai-center">
                                <img src="assets/demo/images/avatar/avatar-1.png"/>
                                <div class="p-d-flex p-flex-column"
                                     [ngClass]="{'p-ml-3': !app.isRTL, 'p-mr-3': app.isRTL}" style="flex-grow: 1;">
                                    <div class="p-d-flex p-ai-center p-jc-between p-mb-1">
                                        <span class="fs-small p-text-bold">Jerome Bell</span>
                                        <small>42 mins ago</small>
                                    </div>
                                    <span class="fs-small">How to write content about your photographs?</span>
                                </div>
                            </div>
                        </li>
                        <li class="layout-topbar-action-item">
                            <div class="p-d-flex p-flex-row p-ai-center">
                                <img src="assets/demo/images/avatar/avatar-2.png"/>
                                <div class="p-d-flex p-flex-column"
                                     [ngClass]="{'p-ml-3': !app.isRTL, 'p-mr-3': app.isRTL}" style="flex-grow: 1;">
                                    <div class="p-d-flex p-ai-center p-jc-between p-mb-1">
                                        <span class="fs-small p-text-bold">Cameron Williamson</span>
                                        <small>48 mins ago</small>
                                    </div>
                                    <span class="fs-small">Start a blog to reach your creative peak.</span>
                                </div>
                            </div>
                        </li>
                        <li class="layout-topbar-action-item">
                            <div class="p-d-flex p-flex-row p-ai-center">
                                <img src="assets/demo/images/avatar/avatar-3.png"/>
                                <div class="p-d-flex p-flex-column"
                                     [ngClass]="{'p-ml-3': !app.isRTL, 'p-mr-3': app.isRTL}" style="flex-grow: 1;">
                                    <div class="p-d-flex p-ai-center p-jc-between p-mb-1">
                                        <span class="fs-small p-text-bold">Anna Miles</span>
                                        <small>1 day ago</small>
                                    </div>
                                    <span class="fs-small">Caring is the new marketing</span>
                                </div>
                            </div>
                        </li>
                        <li class="layout-topbar-action-item">
                            <div class="p-d-flex p-flex-row p-ai-center">
                                <img src="assets/demo/images/avatar/avatar-4.png"/>
                                <div class="p-d-flex p-flex-column"
                                     [ngClass]="{'p-ml-3': !app.isRTL, 'p-mr-3': app.isRTL}" style="flex-grow: 1;">
                                    <div class="p-d-flex p-ai-center p-jc-between p-mb-1">
                                        <span class="fs-small p-text-bold">Arlene Mccoy</span>
                                        <small>4 day ago</small>
                                    </div>
                                    <span class="fs-small">Starting your traveling blog with Vasco.</span>
                                </div>
                            </div>
                        </li>
                    </ul>
                </li>
                <li class="layout-topbar-item p-cursor app p-d-xl-none p-d-flex p-ai-center"
                    (click)="authService.logout()">
                    <a class="layout-topbar-action rounded-circle"
                       pRipple>
                        <i class="pi pi-power-off fs-large"></i>
                        <div class="p-ml-1">Logout</div>
                    </a>
                </li>

                <li class="layout-topbar-item p-cursor app p-d-xl-none p-d-flex p-ai-center"
                    [routerLink]="['/', 'config-control']">
                    <a class="layout-topbar-action rounded-circle"
                       pRipple>
                        <i class="pi pi-cog fs-large"></i>
                        <div class="p-ml-1">Settings</div>
                    </a>
                </li>

                <!--Profile Image & UserName-->
                <li class="layout-topbar-item p-d-none p-d-xl-flex">
                    <img style="height: 3.5rem" src="assets/branding/tw-logo-white.png" alt="" class="p-mr-5">
                </li>
                <li class="layout-topbar-item">
                    <div>
                        <div>
                            Welcome
                        </div>
                        <div class="p-mt-1 p-text-bold">
                            {{loggedInUser?.firstName ? loggedInUser?.firstName : 'User'}}
                        </div>
                    </div>
                    <a class="layout-topbar-action p-d-flex p-dir-row p-jc-center p-ai-center p-px-2"
                       pRipple>
                        <img src="assets/branding/avatar.svg" alt="avatar" style="width: 3rem; border-radius: 50%">
                    </a>
                </li>
                <!--Action Topbar Menu-->
                <li class="layout-topbar-item p-d-none p-d-xl-flex">
                    <div class="layout-topbar-action p-dir-row rounded-circle"
                         (click)="appMain.onTopbarItemClick($event, 'menu-options')" pRipple>
                        <i class="pi pi-ellipsis-v" style="font-size: 1.75rem;"></i>

                    </div>
                    <div class="layout-topbar-action-panel p-shadow-6" [@topbarActionPanelAnimation]="'visible'"
                         *ngIf="appMain.activeTopbarItem === 'menu-options'">

                        <div class="layout-topbar-action-item">
                            <p-multiSelect
                                #companiesSelection
                                class="company-selection companies-selection"
                                (onPanelHide)="appMain.onTopbarItemClick($event, ''); storeSelectedCompanies()"
                                [(ngModel)]="selectedCompanies"
                                [baseZIndex]="1000"
                                [defaultLabel]="'Select Companies'"
                                optionLabel="domainName"
                                placeholder="Select Companies"
                                [filter]="true"
                                filterBy="domainName"
                                [options]="companies" [selectedItemsLabel]="'{0} companies selected'"
                                [showHeader]="true"
                            >
                                <ng-template pTemplate="header">
                                    <div class="apply-button p-ai-center">
                                        <button (click)="storeSelectedCompanies(); companiesSelection.close($event)"
                                                pButton pRipple type="button"
                                                class="p-button-icon p-m-0 apply-button-size check-button-size"
                                                icon="pi pi-check"></button>
                                    </div>
                                </ng-template>
                                <!--                                <ng-template pTemplate="footer">-->
                                <!--                                    <div class="p-text-right p-p-2 p-ai-center">-->
                                <!--                                        <button (click)="appMain.onTopbarItemClick($event, '')"-->
                                <!--                                                pButton pRipple type="button" icon="pi pi-check"></button>-->
                                <!--                                    </div>-->
                                <!--                                </ng-template>-->
                            </p-multiSelect>
                        </div>

                        <div (click)="appMain.onTopbarItemClick($event, '')" class="layout-topbar-action-item">
                            <a class="p-d-flex p-flex-row p-ai-center" pRipple [routerLink]="['/', 'config-control']">
                                <i class="pi pi-cog" [ngClass]="{'p-mr-2': !app.isRTL, 'p-ml-2': app.isRTL}"></i>
                                <span>Settings</span>
                            </a>
                        </div>


                        <div class="layout-topbar-action-item">
                            <a class="p-d-flex p-flex-row p-ai-center" pRipple
                               (click)="authService.logout(); appMain.onTopbarItemClick($event, '')">
                                <i class="pi pi-power-off" [ngClass]="{'p-mr-2': !app.isRTL, 'p-ml-2': app.isRTL}"></i>
                                <span>Logout</span>
                            </a>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</div>


<!--<p-sidebar [(visible)]="switchUserRole" class="bg-color"-->
<!--           [fullScreen]="true" [baseZIndex]="10000" [modal]="true" [blockScroll]="true"-->
<!--           [style]="{overflow: 'hidden'}">-->
<!--    <user-roles (applyFilter)="applyFilterToSelectedUser($event)"></user-roles>-->
<!--</p-sidebar>-->

<!--<div class="layout-topbar p-shadow-4">-->
<!--    <div class="layout-topbar-left">-->
<!--        <a class="layout-topbar-logo" routerLink="/">-->
<!--            <img class="p-mt-1" src="assets/branding/patang-logo.svg" alt="patang" style="height: 4.55rem">-->
<!--            &lt;!&ndash;            <h3 class="p-m-0">TW Freight</h3>&ndash;&gt;-->
<!--        </a>-->

<!--        <a class="layout-menu-button p-shadow-6" (click)="appMain.onMenuButtonClick($event)" pRipple>-->
<!--            <i class="pi pi-chevron-right"></i>-->
<!--        </a>-->

<!--        <a class="layout-topbar-mobile-button" (click)="appMain.onTopbarMobileButtonClick($event)" pRipple>-->
<!--            &lt;!&ndash;                    <button (click)="switchUserRole = true" pButton pRipple&ndash;&gt;-->
<!--            &lt;!&ndash;                            class="p-button-text p-button-info p-d-none p-d-sm-block"&ndash;&gt;-->
<!--            &lt;!&ndash;                            label="Switch User Role"></button>&ndash;&gt;-->
<!--            <i class="p-ml-3 pi pi-exclamation-triangle fs-large"></i>-->

<!--        </a>-->
<!--    </div>-->

<!--    <div class="layout-topbar-right"-->
<!--         [ngClass]="{'layout-topbar-mobile-active': appMain.mobileTopbarActive}">-->
<!--        <div class="layout-topbar-actions-left p-text-secondary">-->

<!--            &lt;!&ndash;            <p-megaMenu [model]="model" styleClass="layout-megamenu"></p-megaMenu>&ndash;&gt;-->
<!--        </div>-->
<!--        &lt;!&ndash;        <div class="p-mb-5 switch-role-button">&ndash;&gt;-->
<!--        &lt;!&ndash;            <button (click)="switchUserRole = true" pButton pRipple class="p-button-text p-button-info"&ndash;&gt;-->
<!--        &lt;!&ndash;                    label="Switch User Role"></button>&ndash;&gt;-->
<!--        &lt;!&ndash;        </div>&ndash;&gt;-->
<!--        <div class="layout-topbar-actions-right">-->
<!--            <ul class="layout-topbar-items">-->

<!--                <li class="layout-topbar-item">-->
<!--                    <div class="layout-topbar-action" style="cursor: text">-->
<!--                        <div>-->
<!--                            <div>-->
<!--                                <h5 class="p-m-0 p-text-light">-->
<!--                                    Welcome-->
<!--                                </h5>-->
<!--                                <div class="p-text-bold" style="padding-top: 1px ">-->
<!--                                    <h5 class="p-m-0">{{loggedInUser?.firstName ? loggedInUser?.firstName : 'User '}}</h5>-->
<!--                                </div>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                    </div>-->

<!--                    <div class="layout-topbar-action">-->
<!--                        &lt;!&ndash;                        <img src="assets/demo/images/avatar/fp-avatar.png" alt="avatar">&ndash;&gt;-->
<!--                        <img src="assets/branding/profile-default.png" alt="avatar" style="width: 6.5vmin">-->
<!--                    </div>-->

<!--                    <div class="layout-topbar-action p-dir-row rounded-circle"-->
<!--                         (click)="appMain.onTopbarItemClick($event, 'menu-options')" pRipple>-->
<!--                        <i class="pi pi-ellipsis-v" style="font-size: 1.75rem;"></i>-->

<!--                    </div>-->

<!--                    <div class="layout-topbar-action-panel p-shadow-6" [@topbarActionPanelAnimation]="'visible'"-->
<!--                         *ngIf="appMain.activeTopbarItem === 'menu-options'">-->

<!--                        <div class="layout-topbar-action-item">-->
<!--                            <p-multiSelect-->
<!--                                #companiesSelection-->
<!--                                class="company-selection companies-selection"-->
<!--                                (onPanelHide)="appMain.onTopbarItemClick($event, '');"-->
<!--                                [(ngModel)]="selectedCompanies"-->
<!--                                [baseZIndex]="1000"-->
<!--                                [defaultLabel]="'Select Companies'"-->
<!--                                optionLabel="domainName"-->
<!--                                placeholder="Select Companies"-->
<!--                                [filter]="true"-->
<!--                                filterBy="domainName"-->
<!--                                [options]="companies" [selectedItemsLabel]="'{0} companies selected'"-->
<!--                                [showHeader]="true"-->
<!--                            >-->
<!--                                <ng-template pTemplate="header">-->
<!--                                    <div class="apply-button p-ai-center">-->
<!--                                        <button (click)="storeSelectedCompanies(); companiesSelection.close($event)"-->
<!--                                                pButton pRipple type="button" class="p-button-icon p-m-0 apply-button-size check-button-size"-->
<!--                                                icon="pi pi-check"></button>-->
<!--                                    </div>-->
<!--                                </ng-template>-->
<!--                                &lt;!&ndash;                                <ng-template pTemplate="footer">&ndash;&gt;-->
<!--                                &lt;!&ndash;                                    <div class="p-text-right p-p-2 p-ai-center">&ndash;&gt;-->
<!--                                &lt;!&ndash;                                        <button (click)="appMain.onTopbarItemClick($event, '')"&ndash;&gt;-->
<!--                                &lt;!&ndash;                                                pButton pRipple type="button" icon="pi pi-check"></button>&ndash;&gt;-->
<!--                                &lt;!&ndash;                                    </div>&ndash;&gt;-->
<!--                                &lt;!&ndash;                                </ng-template>&ndash;&gt;-->
<!--                            </p-multiSelect>-->
<!--                        </div>-->

<!--                        <div (click)="appMain.onTopbarItemClick($event, '')" class="layout-topbar-action-item">-->
<!--                            <a class="p-d-flex p-flex-row p-ai-center" pRipple [routerLink]="['/', 'config-control']">-->
<!--                                <i class="pi pi-cog" [ngClass]="{'p-mr-2': !app.isRTL, 'p-ml-2': app.isRTL}"></i>-->
<!--                                <span>Settings</span>-->
<!--                            </a>-->
<!--                        </div>-->

<!--                        <div class="layout-topbar-action-item">-->
<!--                            <a class="p-d-flex p-flex-row p-ai-center" pRipple-->
<!--                               (click)="authService.logout(); appMain.onTopbarItemClick($event, '')">-->
<!--                                <i class="pi pi-power-off" [ngClass]="{'p-mr-2': !app.isRTL, 'p-ml-2': app.isRTL}"></i>-->
<!--                                <span>Logout</span>-->
<!--                            </a>-->
<!--                        </div>-->
<!--                    </div>-->


<!--                </li>-->


<!--            </ul>-->
<!--        </div>-->
<!--    </div>-->
<!--</div>-->
